import { Box, styled } from '@material-ui/core';
import { AIIcon } from '@setvi/shared/components/sicons';
import { TextColor } from '@setvi/shared/enums';
import { CSSProperties } from 'react';

const AIMatchBadge = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  borderRadius: 99,
  width: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.common.white,
  gap: theme.spacing(1)
}));

const getBgColor = (val: ProductMatchProps['value']) => {
  if (val >= 80) return TextColor.Green;
  if (val > 50) return TextColor.Orange;

  return TextColor.Red;
};

interface ProductMatchProps {
  value: number;
  fontSize?: CSSProperties['fontSize'];
  fontWeight?: CSSProperties['fontWeight'];
}

export const AIProductMatchBadge = ({
  value,
  fontSize = 14,
  fontWeight = 400
}: ProductMatchProps) => (
  <AIMatchBadge
    style={{ backgroundColor: getBgColor(value), fontSize, fontWeight }}>
    <AIIcon fill="#fff" style={{ fontSize }} />
    {value}%
  </AIMatchBadge>
);
